import React from "react";
import { Compass } from "lucide-react";

// Pulsante "Guida rapida" per avviare il mini-tour di una pagina.
export const GuidaRapidaButton = ({ onClick }) => (
  <button
    onClick={onClick}
    data-testid="page-tour-btn"
    className="flex items-center gap-1.5 text-[13px] font-bold text-[#16345c] border border-[#16345c]/30 rounded-full px-3.5 py-1.5 hover:bg-[#16345c] hover:text-white transition-colors shrink-0"
  >
    <Compass size={15} /> Guida rapida
  </button>
);

export default GuidaRapidaButton;
